import defaultAttributes from '../defaultAttributes';

const CircleEllipsis = [
  'svg',
  defaultAttributes,
  [
    ['circle', { cx: '12', cy: '12', r: '10' }],
    ['path', { d: 'M17 12h.01' }],
    ['path', { d: 'M12 12h.01' }],
    ['path', { d: 'M7 12h.01' }],
  ],
];

export default CircleEllipsis;
